import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, intlShape} from 'react-intl';
import VM from 'scratch-vm';

import defaultBackdropTags from '../lib/libraries/backdrop-tags';
import LibraryComponent from '../components/library/library.jsx';
import {loadLibraryTags} from '../lib/library-tags';
import {
    loadScratchResources,
    SCRATCH_RESOURCE_PAGE_SIZE
} from '../lib/scratch-resource-library';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Backdrop',
        description: 'Heading for the backdrop library',
        id: 'gui.costumeLibrary.chooseABackdrop'
    }
});

const RESOURCE_TYPE = 'BACKDROP';
const BACKDROP_TAG_DICT_CODE = 'scratch_backdrop_tag';

class BackdropLibrary extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect',
            'handleRequestQuery'
        ]);
        this.state = {
            backdrops: [],
            hasMore: true,
            isLoading: false,
            tags: []
        };
        this.mounted = false;
        this.requestId = 0;
    }
    componentDidMount () {
        this.mounted = true;
        loadLibraryTags(BACKDROP_TAG_DICT_CODE, defaultBackdropTags)
            .then(tags => {
                if (!this.mounted) return;
                this.setState({tags});
            });
    }
    componentWillUnmount () {
        this.mounted = false;
    }
    handleItemSelect (item) {
        const vmBackdrop = {
            name: item.name,
            rotationCenterX: item.rotationCenterX,
            rotationCenterY: item.rotationCenterY,
            bitmapResolution: item.bitmapResolution,
            skinId: null
        };
        // Do not switch to stage, just add the backdrop
        this.props.vm.addBackdrop(item.md5ext, vmBackdrop);
    }
    handleRequestQuery (query) {
        const currentRequestId = this.requestId + 1;
        this.requestId = currentRequestId;
        const loadingState = {
            hasMore: true,
            isLoading: true
        };
        if (!query.append) {
            loadingState.backdrops = [];
        }
        this.setState(loadingState);

        return loadScratchResources(query, RESOURCE_TYPE)
            .then(({hasMore, records, response}) => {
                if (currentRequestId !== this.requestId) return response;

                const nextBackdrops = query.append ?
                    this.state.backdrops.concat(records) :
                    records;
                this.setState({
                    backdrops: nextBackdrops,
                    hasMore,
                    isLoading: false
                });
                return response;
            })
            .catch(() => {
                if (currentRequestId === this.requestId) {
                    this.setState({
                        hasMore: false,
                        isLoading: false
                    });
                }
                return null;
            });
    }
    render () {
        return (
            <LibraryComponent
                data={this.state.backdrops}
                hasMore={this.state.hasMore}
                id="backdropLibrary"
                isLoading={this.state.isLoading}
                pageSize={SCRATCH_RESOURCE_PAGE_SIZE}
                scopeFilterable
                tags={this.state.tags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
                onRequestQuery={this.handleRequestQuery}
            />
        );
    }
}

BackdropLibrary.propTypes = {
    intl: intlShape.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(BackdropLibrary);
